/*eslint no-throw-literal: "off"*/
/*eslint no-fallthrough: ["warn", { "commentPattern": "break omitted" }]*/

import authStore from '../stores/authStore';
import crypto from 'crypto-js';

const read = response => {
  switch (response.status) {
    case 400:
    //break omitted
    case 404:
    //break omitted
    case 401:
    //break omitted
    case 500:
      if (response.headers.get('content-type').indexOf('text/plain') !== -1 || response.headers.get('content-type').indexOf('text/html') !== -1) {
        return response.text().then(text => {
          throw text;
        });
      }
      try {
        return response.json().then(json => {
          throw json;
        });
      } catch (e) {
        throw { exception: e, description: 'unknown' };
      }
    default:
      try {
        if (response.headers.get('content-type').indexOf('text/html') !== -1) {
          return response.text();
        }
        if (response.headers.get('content-type').indexOf('application/pdf') !== -1) {
          return response.arrayBuffer();
        }
        return response.json();
      } catch (error) {
        return { message: 'error reading the response', error };
      }
  }
};

const get = (url, { headers = new Headers() } = { headers: new Headers() }) => {
  headers.append('Accept', 'application/json, text/plain, */*');
  return fetch(url, { method: 'GET', headers }).then(read);
};

const post = (url, { headers = new Headers(), data }) => {
  let body;
  if (data) {
    body = JSON.stringify(data);
  }
  headers.append('Accept', 'application/json, text/plain, text/html, */*');
  headers.append('Content-Type', 'application/json;charset=UTF-8');
  return fetch(url, { method: 'POST', headers, body }).then(read);
};

const file = (url, { headers = new Headers(), data }) => {
  let body = new FormData();
  if (data) {
    data.forEach(file => {
      body.append('file', file);
    });
  }
  return fetch(url, { method: 'POST', headers, body: body }).then(read);
};

const put = (url, { headers = new Headers(), data }) => {
  let body;
  if (data) {
    body = JSON.stringify(data);
  }
  headers.append('Accept', 'application/json, text/plain, */*');
  headers.append('Content-Type', 'application/json;charset=UTF-8');
  return fetch(url, { method: 'PUT', headers, body }).then(read);
};

const del = (url, { headers = new Headers() }) => {
  headers.append('Accept', 'application/json, text/plain, text/html, */*');
  return fetch(url, { method: 'DELETE', headers }).then(read);
};

const dealersQueryString = (url, dealers) => {
  if(dealers && dealers.length > 0 && !dealers.includes('all')) {
    return url + `&${dealers.map(dealer => `dealerId=${dealer}`).join('&')}`
  }
  return url;
};

export default {
  get,
  post,
  put,
  delete: del,
  withBearer: {
    get: (url, { headers = new Headers() } = { headers: new Headers() }) => {
      headers.append('Authorization', `${authStore.token}`);
      return get(url, { headers });
    },
    post: (url, { data, headers = new Headers() }) => {
      headers.append('Authorization', `${authStore.token}`);
      return post(url, { data, headers });
    },
    put: (url, { data, headers = new Headers() }) => {
      headers.append('Authorization', `${authStore.token}`);
      return put(url, { data, headers });
    },
    delete: (url, { headers = new Headers() } = { headers: new Headers() }) => {
      headers.append('Authorization', `${authStore.token}`);
      return del(url, { headers });
    },
    file: (url, { data, headers = new Headers() }) => {
      headers.append('Authorization', `${authStore.token}`);
      return file(url, { data, headers });
    },
  },
  withBasic: (username = 'mydeskwebapp', password = 'Sa4WLO5c') => {
    const authdata = crypto.enc.Base64.stringify(crypto.enc.Utf8.parse(`${username}:${password}`));
    return {
      post: (url, { data, headers = new Headers() }) => {
        headers.append('Authorization', `Basic ${authdata}`);
        return post(url, { data, headers });
      }
    };
  },
  dealersQueryString
};
